import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

new Swiper(".media-slider", {
  modules: [Navigation, Pagination, Autoplay],
  pagination: {
    el: ".slider-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".slider-button.-next",
    prevEl: ".slider-button.-prev",
  },
  autoplay: {
    delay: 3000,
  },
  loop: true,
  simulateTouch: false,
  spaceBetween: 30,
  slidesPerView: 1,
  watchSlidesProgress: true,
  autoHeight: true,
  on: {
    slideChangeTransitionEnd: (swiper) => {
      swiper.update();
    },
  },
});
